// extracted by mini-css-extract-plugin
export default {"loader":"Loader__loader-L5AF","loaderText":"Loader__loaderText-phl9"};